import React from "react";
const icon = (
  <svg
    width="576"
    height="512"
    viewBox="0 0 576 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 128C0 92.7 28.7 64 64 64H320C355.3 64 384 92.7 384 128V384C384 419.3 355.3 448 320 448H64C28.7 448 0 419.3 0 384V128ZM559.1 99.8C569.5 105.4 576 116.2 576 128V384C576 395.8 569.5 406.6 559.1 412.2C548.7 417.8 536.1 417.2 526.2 410.6L430.2 346.6L416 337.1V320V192V174.9L430.2 165.4L526.2 101.4C536 94.9 548.6 94.2 559.1 99.8Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
